import { Form } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import propTypes from 'prop-types';
import ReactPhoneInput from 'react-phone-input-2';
import { COUNTRIES_LIST } from 'data/weraise-data/countries-data';

// Create reverse mapping: country name -> ISO code (lowercase for react-phone-input-2)
const countryNameToCode = Object.entries(COUNTRIES_LIST).reduce((acc, [code, name]) => {
  acc[name.toLowerCase()] = code.toLowerCase();
  return acc;
}, {});

const getCountryCode = countryName => {
  if (!countryName) return 'gb';

  // Clean up: remove leading punctuation and "The " prefix
  const normalized = countryName
    .toLowerCase()
    .trim()
    .replace(/^[,.\s]+/, '')
    .replace(/^the\s+/, '');

  return countryNameToCode[normalized] || 'gb';
};

export const RHFPhoneInput = ({ name, label, required, defaultCountry, ...rest }) => {
  const { control } = useFormContext();
  const countryCode = getCountryCode(defaultCountry);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Form.Group>
          {!!label && (
            <Form.Label>
              {label} {required && <span className="text-danger">*</span>}
              {!required && <span className="text-500">(optional)</span>}
            </Form.Label>
          )}
          <ReactPhoneInput
            country={countryCode}
            value={value}
            inputClass="w-100 py-2"
            onChange={phone => onChange(phone)}
            enableLongNumbers={true}
            {...rest}
          />
          {error && (
            <Form.Control.Feedback className="d-block" type="invalid">
              {error.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      )}
    />
  );
};

RHFPhoneInput.propTypes = {
  name: propTypes.string,
  label: propTypes.string,
  required: propTypes.bool,
  defaultCountry: propTypes.string
};
